import React from 'react';
import useTheme from '../hooks/useTheme';

interface ButtonProps {
    variant?: 'primary' | 'secondary' | 'ghost';
    leftIcon?: React.ReactNode;
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    type?: 'button' | 'submit';
    style?: React.CSSProperties;
}

export const Button: React.FC<ButtonProps> = ({
    variant = 'primary',
    leftIcon,
    children,
    onClick,
    disabled = false,
    type = 'button',
    style = {},
}) => {
    const { theme } = useTheme();

    const baseStyle: React.CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '12px 24px',
        borderRadius: theme.borderRadius.r1,
        border: 'none',
        fontSize: '16px',
        fontWeight: 500,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        fontFamily: 'inherit',
        lineHeight: 1.5,
        ...style,
    };

    const variantStyles: Record<string, React.CSSProperties> = {
        primary: {
            background: theme.gradients.button,
            color: theme.text.contrast,
            boxShadow: `0 4px 12px ${theme.colors.primary}30`,
        },
        secondary: {
            backgroundColor: theme.colors.surfaceAlt,
            color: theme.text.primary,
            border: `1px solid ${theme.colors.primary}`,
        },
        ghost: {
            backgroundColor: 'transparent',
            color: theme.text.primary,
            border: `1px solid ${theme.colors.border}`,
        },
    };

    const className = variant === 'primary' ? 'btnPrimary' : variant === 'secondary' ? 'btnSecondary' : 'btnGhost';

    return (
        <button
            type={type}
            className={className}
            style={{ ...baseStyle, ...variantStyles[variant], opacity: disabled ? 0.5 : 1 }}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
        >
            {leftIcon && <span style={{ display: 'flex', alignItems: 'center' }}>{leftIcon}</span>}
            {children}
        </button>
    );
};

